// extracted by css-extract-rspack-plugin
export default {"TabPanelRoot":"Mo6zH"};